import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { CurrentActivePrayerInterface } from 'src/app/interfaces/prayerTime-interface';
import { publicationHomePageStateInterface } from 'src/app/interfaces/publication-interface';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  private categoryTemplateStateSource = new BehaviorSubject([]);
  private currentComponent = new BehaviorSubject([]);
  private templateEbookByCategory = new BehaviorSubject([]);
  private entryPointSource = new BehaviorSubject([]);
  private safariAudioPermissionSrc = new BehaviorSubject(false);
  private showFooter = new BehaviorSubject<boolean>(true);
  private currentlyActiveURL = new BehaviorSubject<string>('');
  private headerComponentState = new BehaviorSubject<string>('');
  
  private publicationHomePageStateSource = new BehaviorSubject<publicationHomePageStateInterface[]>([]);
  private prayerTimeMusicPlayerDataSource = new BehaviorSubject<CurrentActivePrayerInterface[]>([]);

  public currentComponentState = this.currentComponent.asObservable();
  public categoryTemplateState = this.categoryTemplateStateSource.asObservable();
  public publicationHomePageState = this.publicationHomePageStateSource.asObservable();
  public entryPoint = this.entryPointSource.asObservable()
  public currentPrayerTimeData = this.prayerTimeMusicPlayerDataSource.asObservable();
  public safariAudioPermission = this.safariAudioPermissionSrc.asObservable()
  public showFooterInCurrentPage = this.showFooter.asObservable();
  public showHeaderMenuFromActiveURL = this.currentlyActiveURL.asObservable();
  // public templateEbookByCategoryState = this.templateEbookByCategory.asObservable();
  public sendLetterFromKeyboard$ = new Subject<any>;
  public updateHeaderComponentState = this.headerComponentState.asObservable();
  
  constructor() { }

  updateCategoryTemplateState(value: any) {
    this.categoryTemplateStateSource.next(value);
  }

  updatePublicationHomePageState(value: publicationHomePageStateInterface[]) {
    this.publicationHomePageStateSource.next(value);
  }

  updateHeaderComponentStateAfterLoggedIn(value: any) {
    this.headerComponentState.next(value);
  }

  udpateSafariAudioPermission(value: any) {
    this.safariAudioPermissionSrc.next(value);
  }

  updateCurrentComponentState(value: any) {
    this.currentComponent.next(value);
  }

  updateEntryPoint(value: any) {
    this.entryPointSource.next(value);
  }

  updatePrayerTimeData(value : CurrentActivePrayerInterface[]){
    this.prayerTimeMusicPlayerDataSource.next(value);
  }

  updateFooterInCurrentPage(value: boolean){
    this.showFooter.next(value);
  }

  updateCurrentlyActiveURL(value: string){
    this.currentlyActiveURL.next(value);
  }

  sendLetter(letter: any) {
    console.log('DATA STORE SERVICE', letter)
    this.sendLetterFromKeyboard$.next(letter)
  }

}
